import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import usePrev from '../../hooks/usePrev';
import { Tooltip } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  }),
);

const specialEventTimes = [
  '',
  '18:00 ',
  '18:30 ',
  '19:00 ',
  '19:30 ',
  '20:00 ',
  '20:30 ',
  '21:00 ',
  '21:30 ',
  '22:00 ',
  '22:30 ',
  '23:00 ',
  '23:30 ',
];

const specialDrDtTimes = [
  '00:00',
  '00:30',
  '01:00',
  '01:30',
  '02:00',
  '02:30',
  '03:00',
  '03:30',
  '04:00',
  '04:30',
  '05:00',
  '05:30',
  '06:00',
  '06:30',
  '07:00',
  '07:30',
  '08:00',
  '08:30',
  '09:00',
  '09:30',
  '10:00',
  '10:30',
  '11:00',
  '11:30',
  '12:00',
];

interface TPIProps {
  tName: string;
  disabled: boolean;
  time: string;
  timeName: string;
  setEdited: Function;
  setOperationHour: Function;
  hasCheckboxes?: boolean;
  enableDhTime24hr?: boolean;
  isDropDownDisabled?: boolean;
  times: string[];
  tooltip?: string;
  hasEditPermission?: boolean
}
export default function NativeSelects({
  tName,
  disabled,
  time,
  timeName,
  setEdited,
  setOperationHour,
  hasCheckboxes,
  enableDhTime24hr,
  isDropDownDisabled,
  times,
  tooltip = '',
  hasEditPermission = true
}: TPIProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const Open = t('operationHours.start');
  const Close = t('operationHours.finish');

  const { deliveryHours } = useSelector(
    (state: RootStateOrAny) => state.NewOperationHoursReducer,
  );

  const [state, setState] = React.useState<{
    time: string | number;
    name: string;
  }>({
    time: '',
    name: '',
  });

  const dispatch: any = useDispatch();
  const {
    drIsOpened24Hours,
    drIsClosed,
    dtIsClosed,
    dtIsOpened24Hours,
    dhIsOpened24Hours = 'N',
    isCalculated,
    isPreviousDay,
  } = useSelector(
    (state: RootStateOrAny) => state.OperationHoursReducer.entity,
  );
  const [isChecked, setIsChecked] = useState(false);
  const brand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );

  const { Region, Country, CountryId, RestaurantId } = useSelector(
    (state: RootStateOrAny) => state.RestaurantsReducer.entity,
  );

  let availableTimes;

  switch (timeName) {
    case 'arrivalTime':
      availableTimes = [...specialEventTimes, ...times];
      break;
    case 'departureTime':
      availableTimes = [...specialEventTimes, ...times];
      break;
    case 'dtTimeClose':
    case 'drTimeClose':
      availableTimes = [...times, ...specialDrDtTimes];
      break;
    case 'deliveryTimeClose':
      if (isCalculated === 'N' && brand === 'BK' && ((Region === 'NA' && Country === 'Canada' && CountryId === 36) || !RestaurantId)) {
        availableTimes = [...times, ...specialDrDtTimes];
      } else {
        availableTimes = times;
      }
      break;
    default:
      availableTimes = times;
      break;
  }

  useEffect(() => {
    if (
      (
        timeName === 'dtTimeOpen' ||
        timeName === 'dtTimeClose' ||
        timeName === 'drTimeOpen' ||
        timeName === 'drTimeClose' ||
        timeName === 'deliveryTimeOpen' ||
        timeName === 'deliveryTimeClose'
      )
      &&
      (
        drIsClosed === 'Y' ||
        drIsOpened24Hours === 'Y' ||
        dtIsClosed === 'Y' ||
        dtIsOpened24Hours === 'Y' ||
        dhIsOpened24Hours === 'Y'
      )
    ) {
      setIsChecked(true);
    }
  }, [drIsClosed, drIsOpened24Hours, dtIsClosed, dtIsOpened24Hours, dhIsOpened24Hours]);


  const handleChange = (
    event: React.ChangeEvent<{ name?: string; value: unknown }>,
  ) => {
    const name = event.target.name as keyof typeof state;

    dispatch(setEdited(true));
    setState({
      ...state,
      [name]: event.target.value,
    });

    if (timeName === 'arrivalTime') {
      let isPreviousDay = 'N';
      const selectedIndex = (event.target as HTMLSelectElement).selectedIndex;
      if (selectedIndex <= 12) {
        isPreviousDay = 'Y';
      }
      dispatch(
        setOperationHour({
          hourName: timeName,
          hourValue: event.target.value,
          isPreviousDay: isPreviousDay,
        }),
      );
    } else {
      dispatch(
        setOperationHour({
          hourName: timeName,
          hourValue: event.target.value,
        }),
      );
    }
  };

  let value =
    timeName === 'arrivalTime' && isPreviousDay === 'Y'
      ? time
      : time.substring(0, 5);

  if (disabled && hasCheckboxes) {
    if (tName === Open) {
      if (
        (timeName === 'dtTimeOpen' && dtIsClosed === 'Y') ||
        (timeName === 'drTimeOpen' && drIsClosed === 'Y')
      ) {
        value = '';
      } else if (
        (timeName === 'dtTimeOpen' && dtIsOpened24Hours === 'Y') ||
        (timeName === 'drTimeOpen' && drIsOpened24Hours === 'Y') ||
        (timeName === 'deliveryTimeOpen' && dhIsOpened24Hours === 'Y' && brand === 'BK' && ((Region === 'NA' && Country === 'Canada' && CountryId === 36) || !RestaurantId))

      ) {
        value = '00:00';
      }
    }

    if (tName === Close) {
      if (
        (timeName === 'dtTimeClose' && dtIsClosed === 'Y') ||
        (timeName === 'drTimeClose' && drIsClosed === 'Y')
      ) {
        value = '';
      } else if (
        (timeName === 'dtTimeClose' && dtIsOpened24Hours === 'Y') ||
        (timeName === 'drTimeClose' && drIsOpened24Hours === 'Y') ||
        (timeName === 'deliveryTimeClose' && dhIsOpened24Hours === 'Y' && brand === 'BK' && ((Region === 'NA' && Country === 'Canada' && CountryId === 36) || !RestaurantId))
      ) {
        value = '23:59';
      }
    }
  }

  if (
    isCalculated === 'Y' &&
    (timeName === 'deliveryTimeOpen' || timeName === 'deliveryTimeClose')
  ) {
    if (tName === Open) {
      if (dtIsClosed === 'Y' && drIsClosed === 'Y') {
        value = '';
      } else if (dtIsOpened24Hours === 'Y' || drIsOpened24Hours === 'Y') {
        if (deliveryHours.default24HourTimeOpen) {
          value = deliveryHours.default24HourTimeOpen;
        } else {
          value = '00:00';
        }
      }
    }

    if (tName === Close) {
      if (dtIsClosed === 'Y' && drIsClosed === 'Y') {
        value = '';
      } else if (dtIsOpened24Hours === 'Y' || drIsOpened24Hours === 'Y') {
        if (deliveryHours.default24HourTimeClose) {
          value = deliveryHours.default24HourTimeClose;
        } else {
          value = '23:59';
        }
      }
    }
  }

  const wasDisabled = usePrev(disabled);
  useEffect(() => {
    if (wasDisabled && hasCheckboxes) {
      dispatch(
        setOperationHour({
          hourName: timeName,
          hourValue: '',
        }),
      );
    }
  }, [dispatch, setOperationHour, timeName, wasDisabled, hasCheckboxes]);

  useEffect(() => {
    if (
      disabled &&
      isChecked &&
      timeName !== 'deliveryTimeOpen' &&
      timeName !== 'deliveryTimeClose'
    ) {
      if (tName === Open) {
        dispatch(
          setOperationHour({
            hourName: timeName,
            hourValue: '00:00',
          }),
        );
      }
      if (tName === Close) {
        dispatch(
          setOperationHour({
            hourName: timeName,
            hourValue: '23:59',
          }),
        );
      }
    }
  }, [disabled, tName, timeName, isChecked]);

  if (
    timeName === 'arrivalTime' &&
    isPreviousDay === 'Y' &&
    value &&
    value != ''
  ) {
    value = `${value} `;
  }

  let deliveryNotExist = false;
  if ((timeName === 'deliveryTimeOpen' || timeName === 'deliveryTimeClose') &&
    !availableTimes.find((elem) => elem === value)) {
    deliveryNotExist = true;
  }

  let isEnabled = isCalculated === 'N' && (timeName === 'deliveryTimeOpen' || timeName === 'deliveryTimeClose') && dhIsOpened24Hours === 'N';
  let isDisabled = hasEditPermission ? (isEnabled ? !isEnabled : isDropDownDisabled || disabled) : true

  return (
    <div>
      <Tooltip title={tooltip}>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel htmlFor="outlined-time-native-simple">{tName}</InputLabel>
          <Select
            style={
              isDisabled
                ? { pointerEvents: 'none', color: 'grey' }
                : undefined
            }
            native
            value={value}
            onChange={handleChange}
            label={tName}
            inputProps={{
              name: 'time',
              id: 'outlined-time-native-simple',
            }}
            disabled={isDisabled}
          >
            {isCalculated === 'Y' &&
              (timeName === 'deliveryTimeOpen' ||
                timeName === 'deliveryTimeClose') ? (
              <option value={value}>{value}</option>
            ) : (timeName === 'dtTimeClose' && dtIsOpened24Hours === 'Y') ||
              (timeName === 'drTimeClose' && drIsOpened24Hours === 'Y') ||
              (timeName === 'deliveryTimeClose' && dhIsOpened24Hours === 'Y') ||
              (timeName === 'dtTimeClose' && dtIsClosed === 'Y') ||
              (timeName === 'drTimeClose' && drIsClosed === 'Y') ? (
              [...availableTimes, '23:59'].map((e, i) => (
                <option key={i} value={e}>
                  {e}
                </option>
              ))
            ) : (
              deliveryNotExist &&
                (timeName === 'deliveryTimeOpen' || timeName === 'deliveryTimeClose') ?
                [...availableTimes, value]?.map((e, i) => (
                  <option key={i} value={e}>{e}</option>
                )) : availableTimes?.map((e, i) => (
                  <option key={i} value={e}>
                    {e}
                  </option>
                ))
            )}
          </Select>
        </FormControl>
      </Tooltip>
    </div>
  );
}
